module.exports = __webpack_public_path__ + "img/flv.402b3294.svg";